export const moduleName = `reportDocuments`
